export default __webpack_public_path__ + "static/media/client-notes.675928c7.svg";